import { type BiLogger, type BiLoggerFactory } from './types';

export { BiLoggerProvider } from './BiLoggerProvider';
export type { BiLogger } from './types';

export const createBiLogger = (biLoggerFactory: BiLoggerFactory): BiLogger => {
  return biLoggerFactory.logger();
};
